import { registerComponent } from '@core/alpine-js';
import noFilterOptions from '../components/listing/no-filter-options';
import categoryProvider from '../components/listing/category-provider';
import activeFilters from '../components/listing/active-filters';
import productInfo from '../components/product/product-info';
import { initCategoryBanner } from '../globals/sliders/category-banner';
import modalAddToCartProductSlider from '../components/product/modalAddToCartProductSlider';

initCategoryBanner();
registerComponent('productInfo', productInfo);
registerComponent('categoryProvider', categoryProvider);
registerComponent('activeFilters', activeFilters);
registerComponent('noFilterOptions', noFilterOptions);
registerComponent('modalAddToCartProductSlider', modalAddToCartProductSlider);
